export default "/images/global.webp?eb7c15578c3eb614cb11861c27c52951";